import * as React from "react";

export const EasyDIYIcon = ({
  width = 48,
  height = 48,
  className,
  title = "Easy DIY",
  ...rest
}: IconProps & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
    {...rest}>
    <title>{title}</title>
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M40.923 66.66V58.3c0-3.08-1.23-6.034-3.419-8.21l-8.191-8.148a2.732 2.732 0 0 0-3.85 0 2.697 2.697 0 0 0 0 3.83l8.143 8.1"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M25.168 42.23V30.99a2.577 2.577 0 0 0-2.584-2.57A2.577 2.577 0 0 0 20 30.99v18.984c0 1.495.598 2.926 1.659 3.984l7.242 7.203a4.844 4.844 0 0 1 1.429 3.433v2.063h10.59v-8.362c0-3.08 1.229-6.033 3.418-8.21l8.191-8.147a2.732 2.732 0 0 1 3.851 0 2.697 2.697 0 0 1 0 3.83l-8.144 8.1"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M56.674 42.23V30.99a2.577 2.577 0 0 1 2.584-2.57 2.577 2.577 0 0 1 2.584 2.57v18.984a5.628 5.628 0 0 1-1.658 3.984l-7.243 7.203a4.844 4.844 0 0 0-1.428 3.433v2.063h-10.59"
    />
    <rect
      width={15.667}
      height={29}
      x={33.158}
      y={13.833}
      stroke="#00226A"
      rx={7.833}
    />
    <circle cx={40.276} cy={22.42} r={2.587} fill="#5DCDFF" />
    <path stroke="#00226A" strokeLinecap="round" d="M38.834 36h4.173" />
  </svg>
);
